import {
  NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  NEXT_PUBLIC_DATADOG_ENV,
  NEXT_PUBLIC_DATADOG_SERVICE,
  NEXT_PUBLIC_ENV,
  NEXT_PUBLIC_VERSION,
} from '../../../appConfig';
import { ignoreErrors } from './ignoreErrors';

export async function initLogs() {
  if (NEXT_PUBLIC_ENV === 'localhost') {
    return;
  }

  const { datadogLogs } = await import('@datadog/browser-logs');
  const { isBot } = await import('@inflearn/monitoring');

  const getSessionSampleRate = () => {
    if (isBot(window.navigator.userAgent)) {
      return 0;
    }

    if (NEXT_PUBLIC_ENV === 'development') {
      return 100;
    }

    return 100;
  };

  datadogLogs.init({
    clientToken: NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? '',
    site: 'datadoghq.com',
    service: NEXT_PUBLIC_DATADOG_SERVICE,
    env: NEXT_PUBLIC_DATADOG_ENV,
    version: NEXT_PUBLIC_VERSION,
    trackSessionAcrossSubdomains: true,
    forwardConsoleLogs: ['info', 'warn', 'error'],
    silentMultipleInit: true,
    sessionSampleRate: getSessionSampleRate(),
    beforeSend: (event) => {
      if (event.status === 'error') {
        const isIgnore = ignoreErrors.some((ignoreError) => {
          if (event?.message?.match(ignoreError.message ?? '')) {
            return true;
          }

          return false;
        });

        // ignore error가 아닌 경우에만 datadog에 전송
        return !isIgnore;
      }

      return true;
    },
  });
}
